<!-- Here Map -->
<div style="height: 100%">
  <div style="width: 100%; min-height: 150px; height: 100%" #mapContainer></div>
</div>
